import script from "./HeroBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroBanner.vue?vue&type=script&setup=true&lang=js"

import "./HeroBanner.vue?vue&type=style&index=0&id=ba99d900&lang=scss"

const __exports__ = script;

export default __exports__